import { render, staticRenderFns } from "./idHome.vue?vue&type=template&id=c448b80e&scoped=true"
import script from "./idHome.vue?vue&type=script&lang=js"
export * from "./idHome.vue?vue&type=script&lang=js"
import style0 from "./idHome.vue?vue&type=style&index=0&id=c448b80e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c448b80e",
  null
  
)

export default component.exports